"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getIterator2 = require("babel-runtime/core-js/get-iterator");

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _regenerator = require("babel-runtime/regenerator");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require("babel-runtime/helpers/asyncToGenerator");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _smartFormShared = require("./smartFormShared");

var _smartFormShared2 = _interopRequireDefault(_smartFormShared);

var _common = require("../common");

var _common2 = _interopRequireDefault(_common);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var smartFormMvc = {
    registerSmartFormMvcOnce: function registerSmartFormMvcOnce(instanceIdentifier) {
        var _this = this;

        return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
            var sfInput, smartFormInstance;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.prev = 0;

                            /* 
                                Registration runs in loop, but there is a test, if is already registered. 
                                Dataset property 'registered' of first input of Sf instance is tested.
                                The reason is, form is loaded by ajax and once MVC ajax post is performed, Sf registration is broken.
                             */
                            sfInput = document.querySelector("." + instanceIdentifier);

                            if (!(sfInput && sfInput.dataset.registered === 'true')) {
                                _context.next = 4;
                                break;
                            }

                            return _context.abrupt("return");

                        case 4:
                            _context.next = 6;
                            return smartFormMvc.registerSmartFormCallBack(instanceIdentifier);

                        case 6:
                            if (_smartFormShared2.default.checkSmartForm(false, false, true)) {
                                _context.next = 8;
                                break;
                            }

                            return _context.abrupt("return");

                        case 8:
                            smartFormInstance = smartform.getInstance(instanceIdentifier);
                            _context.next = 11;
                            return smartFormMvc.registerEmailValidation(smartFormInstance);

                        case 11:

                            if (sfInput) sfInput.dataset.registered = 'true';
                            _context.next = 17;
                            break;

                        case 14:
                            _context.prev = 14;
                            _context.t0 = _context["catch"](0);

                            console.error('Error registering SmartForm once (method: registerSmartFormMvcOnce).', _context.t0);

                        case 17:
                        case "end":
                            return _context.stop();
                    }
                }
            }, _callee, _this, [[0, 14]]);
        }))();
    },
    registerSmartFormCallBack: function registerSmartFormCallBack(instanceIdentifier) {
        var _this2 = this;

        return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
            var identifierArray, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, identifier, sfInstance;

            return _regenerator2.default.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            _context2.prev = 0;

                            if (_smartFormShared2.default.checkSmartForm(true)) {
                                _context2.next = 3;
                                break;
                            }

                            return _context2.abrupt("return");

                        case 3:
                            // if identifier is not assigned explicitly, init all available instances
                            identifierArray = instanceIdentifier ? [instanceIdentifier] : smartform.getInstanceIds();
                            _iteratorNormalCompletion = true;
                            _didIteratorError = false;
                            _iteratorError = undefined;
                            _context2.prev = 7;
                            _iterator = (0, _getIterator3.default)(identifierArray);

                        case 9:
                            if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                                _context2.next = 20;
                                break;
                            }

                            identifier = _step.value;
                            sfInstance = smartform.getInstance(identifier);

                            _smartFormShared2.default.setBasicSmartFormAttributes(sfInstance);
                            _context2.next = 15;
                            return smartFormMvc.registerSfMvcCallback(sfInstance);

                        case 15:
                            _context2.next = 17;
                            return smartFormMvc.registerAutoTrim("." + identifier);

                        case 17:
                            _iteratorNormalCompletion = true;
                            _context2.next = 9;
                            break;

                        case 20:
                            _context2.next = 26;
                            break;

                        case 22:
                            _context2.prev = 22;
                            _context2.t0 = _context2["catch"](7);
                            _didIteratorError = true;
                            _iteratorError = _context2.t0;

                        case 26:
                            _context2.prev = 26;
                            _context2.prev = 27;

                            if (!_iteratorNormalCompletion && _iterator.return) {
                                _iterator.return();
                            }

                        case 29:
                            _context2.prev = 29;

                            if (!_didIteratorError) {
                                _context2.next = 32;
                                break;
                            }

                            throw _iteratorError;

                        case 32:
                            return _context2.finish(29);

                        case 33:
                            return _context2.finish(26);

                        case 34:
                            _context2.next = 39;
                            break;

                        case 36:
                            _context2.prev = 36;
                            _context2.t1 = _context2["catch"](0);

                            console.error('Error SmartForm setting necessary attributes.', _context2.t1);

                        case 39:
                        case "end":
                            return _context2.stop();
                    }
                }
            }, _callee2, _this2, [[0, 36], [7, 22, 26, 34], [27,, 29, 33]]);
        }))();
    },
    prepareEmailValidation: function prepareEmailValidation(instanceId) {
        var _this3 = this;

        return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4() {
            var emailField;
            return _regenerator2.default.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            if (instanceId) {
                                _context4.next = 2;
                                break;
                            }

                            return _context4.abrupt("return");

                        case 2:
                            emailField = document.querySelector("." + instanceId + ".smartform-email");

                            if (!(!emailField || emailField.registeredFocus)) {
                                _context4.next = 5;
                                break;
                            }

                            return _context4.abrupt("return");

                        case 5:

                            emailField.addEventListener('focus', function () {
                                var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(event) {
                                    var sfInstance;
                                    return _regenerator2.default.wrap(function _callee3$(_context3) {
                                        while (1) {
                                            switch (_context3.prev = _context3.next) {
                                                case 0:
                                                    if (!(emailField.registeredValidation || !_smartFormShared2.default.checkSmartForm(false, false, true))) {
                                                        _context3.next = 2;
                                                        break;
                                                    }

                                                    return _context3.abrupt("return");

                                                case 2:

                                                    emailField.registeredValidation = true;
                                                    sfInstance = smartform.getInstance(instanceId);
                                                    _context3.next = 6;
                                                    return smartFormMvc.registerEmailValidation(sfInstance);

                                                case 6:
                                                case "end":
                                                    return _context3.stop();
                                            }
                                        }
                                    }, _callee3, _this3);
                                }));

                                return function (_x) {
                                    return _ref.apply(this, arguments);
                                };
                            }());
                            emailField.registeredFocus = true;

                        case 7:
                        case "end":
                            return _context4.stop();
                    }
                }
            }, _callee4, _this3);
        }))();
    },
    getEmailField: function getEmailField(sfInstanceId) {
        var _this4 = this;

        return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee5() {
            var emailField, errorElementArray, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, errorElement;

            return _regenerator2.default.wrap(function _callee5$(_context5) {
                while (1) {
                    switch (_context5.prev = _context5.next) {
                        case 0:
                            // check if current SmartForm instance has email input
                            emailField = document.querySelector("." + sfInstanceId + ".smartform-email");

                            if (emailField) {
                                _context5.next = 3;
                                break;
                            }

                            return _context5.abrupt("return", null);

                        case 3:

                            // iv validation message is visible, do not show another
                            errorElementArray = emailField.parentElement.querySelectorAll('.field-validation-error');
                            _iteratorNormalCompletion2 = true;
                            _didIteratorError2 = false;
                            _iteratorError2 = undefined;
                            _context5.prev = 7;

                            for (_iterator2 = (0, _getIterator3.default)(errorElementArray); !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                                errorElement = _step2.value;

                                emailField.errorText = errorElement.textContent;
                                errorElement.parentElement.removeChild(errorElement);
                            }
                            _context5.next = 15;
                            break;

                        case 11:
                            _context5.prev = 11;
                            _context5.t0 = _context5["catch"](7);
                            _didIteratorError2 = true;
                            _iteratorError2 = _context5.t0;

                        case 15:
                            _context5.prev = 15;
                            _context5.prev = 16;

                            if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                _iterator2.return();
                            }

                        case 18:
                            _context5.prev = 18;

                            if (!_didIteratorError2) {
                                _context5.next = 21;
                                break;
                            }

                            throw _iteratorError2;

                        case 21:
                            return _context5.finish(18);

                        case 22:
                            return _context5.finish(15);

                        case 23:
                            return _context5.abrupt("return", emailField);

                        case 24:
                        case "end":
                            return _context5.stop();
                    }
                }
            }, _callee5, _this4, [[7, 11, 15, 23], [16,, 18, 22]]);
        }))();
    },
    registerEmailValidation: function registerEmailValidation(smartFormInstance) {
        var _this5 = this;

        return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee7() {
            var registerKey;
            return _regenerator2.default.wrap(function _callee7$(_context7) {
                while (1) {
                    switch (_context7.prev = _context7.next) {
                        case 0:
                            if (smartFormInstance) {
                                _context7.next = 2;
                                break;
                            }

                            return _context7.abrupt("return");

                        case 2:
                            registerKey = smartFormInstance.getId() + "emailRegistered";

                            if (!(window[registerKey] === true)) {
                                _context7.next = 5;
                                break;
                            }

                            return _context7.abrupt("return");

                        case 5:

                            smartFormInstance.emailControl.addValidationCallback(function () {
                                var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee6(validationResult) {
                                    var validationText, emailField, myForm, isEmailInValidInput;
                                    return _regenerator2.default.wrap(function _callee6$(_context6) {
                                        while (1) {
                                            switch (_context6.prev = _context6.next) {
                                                case 0:
                                                    if (!(!validationResult || !validationResult.result || !validationResult.result.resultType)) {
                                                        _context6.next = 2;
                                                        break;
                                                    }

                                                    return _context6.abrupt("return");

                                                case 2:

                                                    // localized text by status from SmartForm
                                                    validationText = _smartFormShared2.default.getTextByEmailValidationCode(validationResult.result.resultType);

                                                    // check if current SmartForm instance has email input

                                                    _context6.next = 5;
                                                    return smartFormMvc.getEmailField(smartFormInstance.getId());

                                                case 5:
                                                    emailField = _context6.sent;

                                                    if (emailField) {
                                                        _context6.next = 8;
                                                        break;
                                                    }

                                                    return _context6.abrupt("return");

                                                case 8:

                                                    // add an element for validation on server
                                                    myForm = emailField.closest('form');
                                                    isEmailInValidInput = myForm ? myForm.querySelector('#IsEmailInValid') : document.querySelector('#IsEmailInValid');

                                                    if (!isEmailInValidInput) {
                                                        isEmailInValidInput = _common2.default.createElement('input', emailField.parentElement, {
                                                            type: 'hidden', id: 'IsEmailInValid', name: 'IsEmailInValid'
                                                        });
                                                    }
                                                    // for validation (client - dataset and server - hidden field value)
                                                    emailField.dataset.isInvalid = isEmailInValidInput.value = (validationText !== null).toString();

                                                    // populate error to user
                                                    _common2.default.updateValidityView(validationText, emailField, 'smartform-email-validation');
                                                    // this.updateEmailValidityInput(validationText, emailField);

                                                case 13:
                                                case "end":
                                                    return _context6.stop();
                                            }
                                        }
                                    }, _callee6, _this5);
                                }));

                                return function (_x2) {
                                    return _ref2.apply(this, arguments);
                                };
                            }());
                            window[registerKey] = true;

                        case 7:
                        case "end":
                            return _context7.stop();
                    }
                }
            }, _callee7, _this5);
        }))();
    },
    registerSfMvcCallback: function registerSfMvcCallback(smartFormInstance) {
        var _this6 = this;

        return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee8() {
            return _regenerator2.default.wrap(function _callee8$(_context8) {
                while (1) {
                    switch (_context8.prev = _context8.next) {
                        case 0:
                            _context8.next = 2;
                            return smartFormInstance.addressControl.setSelectionCallback(function (element, text, fieldType, suggestion) {
                                $(element).val(text);
                                $(element).trigger('change');
                                if ((element.value || '').length > 0) element.classList.add('input--filled');else element.classList.remove('input--filled');
                            });

                        case 2:
                        case "end":
                            return _context8.stop();
                    }
                }
            }, _callee8, _this6);
        }))();
    },
    registerSmartFormFieldKeyDown: function registerSmartFormFieldKeyDown(instanceId) {
        var _this7 = this;

        return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee9() {
            return _regenerator2.default.wrap(function _callee9$(_context9) {
                while (1) {
                    switch (_context9.prev = _context9.next) {
                        case 0:
                            document.querySelectorAll('.address-field').forEach(function (item) {
                                item.addEventListener('keydown', function (event) {
                                    return _this7.registerSmartFormInputEvent(event, _this7, instanceId);
                                });
                                item.addEventListener('focus', function (event) {
                                    return _this7.registerSmartFormInputEvent(event, _this7, instanceId);
                                });
                            });

                        case 1:
                        case "end":
                            return _context9.stop();
                    }
                }
            }, _callee9, _this7);
        }))();
    },
    registerSmartFormInputEvent: function registerSmartFormInputEvent(event, currentObject, instanceId) {
        var _this8 = this;

        return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee10() {
            return _regenerator2.default.wrap(function _callee10$(_context10) {
                while (1) {
                    switch (_context10.prev = _context10.next) {
                        case 0:
                            if (event.target.registeredKeyDown) {
                                _context10.next = 4;
                                break;
                            }

                            _context10.next = 3;
                            return currentObject.registerSmartFormCallBack(instanceId);

                        case 3:
                            event.target.registeredKeyDown = true;

                        case 4:
                        case "end":
                            return _context10.stop();
                    }
                }
            }, _callee10, _this8);
        }))();
    },
    getMvcSfInstances: function getMvcSfInstances() {
        var _this9 = this;

        var includeVoucher = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
        return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee11() {
            var sfInstances;
            return _regenerator2.default.wrap(function _callee11$(_context11) {
                while (1) {
                    switch (_context11.prev = _context11.next) {
                        case 0:
                            sfInstances = ['smartform-instance-paralel', 'smartform-instance-customer-detail', 'smartform-instance-register', 'smartform-instance-secondary-address'];


                            if (includeVoucher) sfInstances.push('smartform-instance-voucher');
                            return _context11.abrupt("return", sfInstances);

                        case 3:
                        case "end":
                            return _context11.stop();
                    }
                }
            }, _callee11, _this9);
        }))();
    },
    registerAutoTrim: function registerAutoTrim(jointSelector) {
        var _this10 = this;

        return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee12() {
            var smartFormInputList, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, smartFormInput;

            return _regenerator2.default.wrap(function _callee12$(_context12) {
                while (1) {
                    switch (_context12.prev = _context12.next) {
                        case 0:
                            smartFormInputList = document.querySelectorAll(jointSelector);
                            _iteratorNormalCompletion3 = true;
                            _didIteratorError3 = false;
                            _iteratorError3 = undefined;
                            _context12.prev = 4;


                            for (_iterator3 = (0, _getIterator3.default)(smartFormInputList); !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                                smartFormInput = _step3.value;

                                smartFormInput.addEventListener('blur', function (event) {
                                    event.target.value = _smartFormShared2.default.adjustAddressFieldValue(event);
                                });
                            }
                            _context12.next = 12;
                            break;

                        case 8:
                            _context12.prev = 8;
                            _context12.t0 = _context12["catch"](4);
                            _didIteratorError3 = true;
                            _iteratorError3 = _context12.t0;

                        case 12:
                            _context12.prev = 12;
                            _context12.prev = 13;

                            if (!_iteratorNormalCompletion3 && _iterator3.return) {
                                _iterator3.return();
                            }

                        case 15:
                            _context12.prev = 15;

                            if (!_didIteratorError3) {
                                _context12.next = 18;
                                break;
                            }

                            throw _iteratorError3;

                        case 18:
                            return _context12.finish(15);

                        case 19:
                            return _context12.finish(12);

                        case 20:
                        case "end":
                            return _context12.stop();
                    }
                }
            }, _callee12, _this10, [[4, 8, 12, 20], [13,, 15, 19]]);
        }))();
    }
};

exports.default = smartFormMvc;


window.registerSmartFormMvc = function () {
    var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee13(instanceId) {
        return _regenerator2.default.wrap(function _callee13$(_context13) {
            while (1) {
                switch (_context13.prev = _context13.next) {
                    case 0:
                        _context13.next = 2;
                        return smartFormMvc.registerSmartFormFieldKeyDown(instanceId);

                    case 2:
                        _context13.next = 4;
                        return smartFormMvc.prepareEmailValidation(instanceId);

                    case 4:
                        _context13.next = 6;
                        return _common2.default.registerPhoneNumberValidation();

                    case 6:
                    case "end":
                        return _context13.stop();
                }
            }
        }, _callee13, undefined);
    }));

    return function (_x4) {
        return _ref3.apply(this, arguments);
    };
}();

window.registerSmartFormMvcOnce = function () {
    var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee15(instanceId) {
        return _regenerator2.default.wrap(function _callee15$(_context15) {
            while (1) {
                switch (_context15.prev = _context15.next) {
                    case 0:
                        // implementing interval to be sure, Sf is ready
                        window.setInterval((0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee14() {
                            return _regenerator2.default.wrap(function _callee14$(_context14) {
                                while (1) {
                                    switch (_context14.prev = _context14.next) {
                                        case 0:
                                            _context14.next = 2;
                                            return smartFormMvc.registerSmartFormMvcOnce(instanceId);

                                        case 2:
                                        case "end":
                                            return _context14.stop();
                                    }
                                }
                            }, _callee14, undefined);
                        })), 2000);

                    case 1:
                    case "end":
                        return _context15.stop();
                }
            }
        }, _callee15, undefined);
    }));

    return function (_x5) {
        return _ref4.apply(this, arguments);
    };
}();
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/smartform/smartFormMvc.js
// module id = 1091
// module chunks = 0